var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMembershipsView = function SvgMembershipsView(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1679_1592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 5.09094C5.94684 5.09094 5.09094 5.94684 5.09094 7.00003C5.09094 8.05322 5.94684 8.90911 7.00003 8.90911C8.05322 8.90911 8.90911 8.05322 8.90911 7.00003C8.90911 5.94684 8.05319 5.09094 7.00003 5.09094Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 2.22729C3.81818 2.22729 1.10092 4.20637 0 7.00003C1.10092 9.79365 3.81818 11.7728 7.00002 11.7728C10.185 11.7728 12.8991 9.79365 14 7.00003C12.8991 4.20637 10.185 2.22729 7.00002 2.22729ZM7.00002 10.1818C5.24365 10.1818 3.81818 8.75636 3.81818 7C3.81818 5.24363 5.24365 3.8182 7.00002 3.8182C8.75638 3.8182 10.1818 5.24366 10.1818 7.00003C10.1818 8.75639 8.75638 10.1818 7.00002 10.1818Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1679_1592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))));
};
export default SvgMembershipsView;